const messages = {
    gb: {
        country_names: {
            pt: 'Portugal',
            es: 'Spain',
            it: 'Italy'
        },
        languages: {
            gb: 'English',
            pt: 'Portuguese',
            es: 'Spanish',
            it: 'Italian'
        },
        menu: {
            landscape_error: 'This app only works in landscape mode. Please turn your device into landscape.',
            login: {
                login: 'Login',
                create: 'Create account',
                email: 'Email or Username',
                password: 'Password',
                button: 'Let\'s play!',
                about: 'About',
                guest: 'Play as guest'

            },
            create: {
                login: 'Login',
                create: 'Create account',
                email: 'Email',
                username: 'Username',
                password: 'Password',
                confirm: 'Confirm your password',
                button: 'Sign up'
            },
            profile: {
                quit: 'Are you sure you want to logout?',
                save: 'Save'
            },
            settings: {
                title: 'SETTINGS',
                sound: 'Sound Effects',
                music: 'Menu Music',
                language: 'Language',
                teachers: 'For teachers',
                parental: 'Parental Guide',
                help: 'Help and Support',
                credits: 'Credits'
            },
            gallery: {
                title: 'GALLERY',
                melody: 'Melody',
                dance: 'Dance',
                rhythm: 'Rhythm',
                sing: 'Sing',
                no_games_of_type: "You don't have any saved games of type",
                try_creating_game: "Try creating a new game"
            },
            general: {
                quit: 'Are you sure you want to quit the game?'
            }
        },
        games: {
            congratulationsmessages: {
                message1: 'Your music was beautiful!',
                message2: 'Such a nice song!',
                message3: 'Your music is inspiring!',
                message4: 'What a beautiful melody!',
            },
            video: {
                rhythm: 'ritmoing',
                melody: 'melodiaing',
                dance: 'danceing',
                sing: 'singing'
            },

            melody: {
                title: 'COMPOSE YOUR MELODY',
                gamemode: 'Choose the songs you want to play with',
                line: 'Draw a melodic line',
                waiting: 'Waiting for the artificial artist!'
            },
            dance: {
                title: 'DANCE WITH THE MUSIC',
                gamemode: 'Choose the songs you want to play with',
                song: 'Choose a song'
            },
            sing: {
                title: 'SING WITH THE MUSIC',
                gamemode: 'Choose the songs you want to play with',
                song: 'Choose a song'
            },
            rhythm: {
                title: 'MAKE A RHYTHM',
                gamemode: 'Choose the songs you want to play with',
                song: 'Choose a song'
            },
            shared: {
                gamemodes: {
                    portugal: 'Portuguese songs',
                    spain: 'Spanish songs',
                    italy: 'Italian songs',
                    all: 'Party'
                },
                waiting: 'WAITING',
                error: 'ERROR',
                home: 'Home',
                closed: 'Closed',
                back_to_edit: 'Back',
                edit_again: 'View Again',
                save_game: 'Save',
                restart: 'Restart',
                filter_options: {
                    all: 'No Filter',
                    genre: 'Musical Genre',
                    rhythmic_level: 'Rhythm Difficulty',
                    meter_level: 'Meter',
                    melodic_level: 'Melodic Difficulty'
                },
                filter_description: {
                    genre: {
                        Lullaby: 'Lullaby',
                        ChildrenSong: 'Children Song',
                        DanceSong: 'Dance Song'
                    },
                    rhythmic_level: {
                        '1': 'Easy',
                        '2': 'Medium',
                        '3': 'Hard'
                    },
                    meter_level: {
                        '1': 'Binary',
                        '2': 'Ternary',
                        '3': 'Free/Polyrythmic'
                    },
                    melodic_level: {
                        '1': 'Easy',
                        '2': 'Medium',
                        '3': 'Hard'
                    },
                }
            },
        }
    },
    pt: {
        country_names: {
            pt: 'Portugal',
            es: 'Espanha',
            it: 'Itália'
        },
        languages: {
            gb: 'Inglês',
            pt: 'Português',
            es: 'Espanhol',
            it: 'Italiano'
        },
        menu: {
            landscape_error: 'Esta aplicação só funciona em modo horizontal. Por favor, roda o teu dispositivo.',
            login: {
                login: 'Entrar',
                create: 'Criar conta',
                email: 'Email ou Nome de utilizador',
                password: 'Palavra-passe',
                button: 'Vamos jogar!',
                about: 'Sobre',
                guest: 'Jogar como convidado'
            },
            create: {
                login: 'Entrar',
                create: 'Criar conta',
                email: 'Email',
                username: 'Nome de utilizador',
                password: 'Palavra-passe',
                confirm: 'Confirma a tua palavra-passe',
                button: 'Registar'
            },
            profile: {
                quit: 'Tens a certeza de que queres terminar sessão?',
                save: 'Guardar'
            },
            settings: {
                title: 'DEFINIÇÕES',
                sound: 'Efeitos Sonoros',
                music: 'Música do Menu',
                language: 'Idioma',
                teachers: 'Para professores',
                parental: 'Guia Parental',
                help: 'Ajuda e Suporte',
                credits: 'Créditos'
            },
            gallery: {
                title: 'GALERIA',
                melody: 'Melodia',
                dance: 'Dança',
                rhythm: 'Ritmo',
                sing: 'Canto'
            },
            general: {
                quit: 'Tens a certeza de que queres sair do jogo?'
            }
        },
        games: {
            congratulationsmessages: {
                message1: 'A tua música ficou bonita!',
                message2: 'Que boa música!',
                message3: 'A tua música é inspiradora!',
                message4: 'Que linda melodia!',
            },

            video: {
                rhythm: 'ritmopt',
                melody: 'melodiapt',
                dance: 'dancept',
                sing: 'singpt'
            },
            melody: {
                title: 'CRIA A TUA MELODIA',
                gamemode: 'Escolhe a música em que queres jogar',
                line: 'Desenhe uma linha melódica',
            },
            dance: {
                title: 'DANÇA COM A MÚSICA',
                gamemode: 'Escolhe a música em que queres jogar',
                song: 'Escolhe uma música'
            },
            sing: {
                title: 'CANTA COM A MÚSICA',
                gamemode: 'Escolhe a música em que queres jogar',
                song: 'Escolhe uma música'
            },
            rhythm: {
                title: 'CRIA UM RITMO',
                gamemode: 'Escolhe a música em que queres jogar',
                song: 'Escolhe uma música'
            },
            shared: {
                gamemodes: {
                    portugal: 'Músicas portuguesas',
                    spain: 'Músicas espanholas',
                    italy: 'Músicas italianas',
                    all: 'Festa'
                },
                waiting: 'WAITING',
                error: 'ERRO',
                home: 'Menu',
                closed: 'Fechar',
                restart: 'Recomeçar',
                back_to_edit: 'Atrás',
                edit_again: 'Outra vez',
                save_game: 'Guardar',
                filter_options: {
                    all: 'Sem Filtro',
                    genre: 'Género Musical',
                    rhythmic_level: 'Dificuldade Rítmica',
                    meter_level: 'Dificuldade Métrica',
                    melodic_level: 'Dificuldade Melódica'
                },
                filter_description: {
                    genre: {
                        Lullaby: 'Canção de Embalar',
                        ChildrenSong: 'Canção Infantil',
                        DanceSong: 'Canção de Dança'
                    },
                    rhythmic_level: {
                        '1': 'Fácil',
                        '2': 'Médio',
                        '3': 'Difícil'
                    },
                    meter_level: {
                        '1': 'Binário',
                        '2': 'Ternário',
                        '3': 'Livre/Polirritmico'
                    },
                    melodic_level: {
                        '1': 'Fácil',
                        '2': 'Médio',
                        '3': 'Difícil'
                    },
                }
            },
        }
    },
    es: {
        country_names: {
            pt: 'Portugal',
            es: 'España',
            it: 'Italia'
        },
        languages: {
            gb: 'Inglés',
            pt: 'Portugués',
            es: 'Español',
            it: 'Italiano'
        },
        menu: {
            landscape_error: 'Esta aplicación solo funciona en modo horizontal. Por favor gire su dispositivo.',
            login: {
                login: 'Acceso',
                create: 'Crear una cuenta',
                email: 'Email o Nombre de usuario',
                password: 'Contraseña',
                button: 'Vamos a jugar!',
                about: 'Sobre',
                guest: 'Jugar como invitado'
            },
            create: {
                login: 'Acceso',
                create: 'Crear una cuenta',
                email: 'Email',
                username: 'Nombre de usuario',
                password: 'Contraseña',
                confirm: 'Confirmar la contraseña',
                button: 'Inscribirse'
            },
            profile: {
                quit: '¿Está seguro(a) de que desea cerrar la sesión?',
                save: 'Guardar'
            },
            settings: {
                title: 'DEFINICIONES',
                sound: 'Efectos sonoros',
                music: 'Musica de Menu',
                language: 'Idioma',
                teachers: 'Para maestros',
                parental: 'Guía para Padres',
                help: 'Ayuda y Apoyo',
                credits: 'Creditos'
            },
            gallery: {
                title: 'GALERÍA',
                melody: 'Melodía',
                dance: 'Danza',
                rhythm: 'Ritmo',
                sing: 'Canto'
            },
            general: {
                quit: '¿Estás seguro(a) de que quieres salir del juego?'
            }
        },
        games: {
            congratulationsmessages: {
                message1: '¡Tu música es hermosa!',
                message2: '¡Qué buena música!',
                message3: '¡Tu música es inspiradora!',
                message4: '¡Qué hermosa melodía!'
            },
            video: {
                rhythm: 'ritmoes',
                melody: 'melodiaes',
                dance: 'dancees',
                sing: 'singes'
            },

            melody: {
                title: 'CREA TU MELODÍA',
                gamemode: 'Elige la música que quieres jugar',
                line: 'Disegna una linea melodica'
            },
            dance: {
                title: 'BAILAR CON LA MÚSICA',
                gamemode: 'Elige la música que quieres jugar',
                song: 'Elije una canción'
            },
            sing: {
                title: 'CANTA CON LA MÚSICA',
                gamemode: 'Elige la música que quieres jugar',
                song: 'Elije una canción'
            },
            rhythm: {
                title: 'CREA UN RITMO',
                gamemode: 'Elige la música que quieres jugar',
                song: 'Elije una canción'
            },
            shared: {
                gamemodes: {
                    portugal: 'Canciones portuguesas',
                    spain: 'Canciones españolas',
                    italy: 'Canciones italianas',
                    all: 'Fiesta'
                },
                waiting: 'WAITING',
                error: 'ERROR',
                home: 'Menú',
                closed: 'Cerrar',
                back_to_edit: 'Atrás',
                edit_again: 'Outra vez',
                save_game: 'Guardar',
                restart: 'Reiniciar',
                filter_options: {
                    all: 'Sin Filtro',
                    genre: 'Genero Musical',
                    rhythmic_level: 'Dificultad rítmica',
                    meter_level: 'Dificultad métrica',
                    melodic_level: 'Dificultad melódica'
                },
                filter_description: {
                    genre: {
                        Lullaby: 'Canción de Cuna',
                        ChildrenSong: 'Canción Infantil',
                        DanceSong: 'Canción de Baile'
                    },
                    rhythmic_level: {
                        '1': 'Fácil',
                        '2': 'Medio',
                        '3': 'Difícil'
                    },
                    meter_level: {
                        '1': 'Binario',
                        '2': 'Ternario',
                        '3': 'Libre/Polirítmico'
                    },
                    melodic_level: {
                        '1': 'Fácil',
                        '2': 'Medio',
                        '3': 'Difícil'
                    },
                }
            },
        }
    },
    it: {
        country_names: {
            pt: 'Portogallo',
            es: 'Spagna',
            it: 'Italia'
        },
        languages: {
            gb: 'Inglese',
            pt: 'Portoghese',
            es: 'Spagnolo',
            it: 'Italiano'
        },
        menu: {
            landscape_error: 'Questa applicazione funziona solo in modalità orizzontale. Si prega di ruotare il dispositivo.',
            login: {
                login: 'Login',
                create: 'Creare un profilo',
                email: 'E-mail ou Nome utente',
                password: 'Password',
                button: 'Vamos jogar!',
                about: 'Sobre',
                guest: 'Giocare come ospite'
            },
            create: {
                login: 'Login',
                create: 'Creare un profilo',
                email: 'E-mail',
                username: 'Nome utente',
                password: 'Password',
                confirm: 'Conferma la tua password',
                button: 'Iscriviti'
            },
            profile: {
                quit: 'Sei sicuro di voler uscire?',
                save: 'Salva'
            },
            settings: {
                title: 'IMPOSTAZIONI',
                sound: 'Effetti Sonori',
                music: 'Menu Musica',
                language: 'Linguaggio',
                teachers: 'Per gli insegnanti',
                parental: 'Guida per i genitori',
                help: 'Aiuto e Supporto',
                credits: 'Titoli di Coda'
            },
            gallery: {
                title: 'GALLERIA',
                melody: 'Melodia',
                dance: 'Danza',
                rhythm: 'Ritmo',
                sing: 'Canto'
            },
            general: {
                quit: 'Sei sicuro di voler chiudere il gioco?'
            }
        },
        games: {
            congratulationsmessages: {
                message1: 'La tua musica è bellissima!',
                message2: 'Che bella musica!',
                message3: 'La tua musica è stimolante!',
                message4: 'Che bella melodia!'
            },
            video: {
                rhythm: 'ritmoit',
                melody: 'melodiait',
                dance: 'danceit',
                sing: 'singit'
            },

            melody: {
                title: 'CREA LA TUA MELODIA',
                gamemode: 'Scegli la musica a cui vuoi giocare',
                line: 'Disegna una linea melodica'
            },
            dance: {
                title: 'DANZA CON LA MUSICA',
                gamemode: 'Scegli la musica a cui vuoi giocare',
                song: 'Scegli una canzone'
            },
            sing: {
                title: 'CANTA CON LA MUSICA',
                gamemode: 'Scegli la musica a cui vuoi giocare',
                song: 'Scegli una canzone'
            },
            rhythm: {
                title: 'CREA UN RITMO',
                gamemode: 'Scegli la musica a cui vuoi giocare',
                song: 'Scegli una canzone'
            },
            shared: {
                gamemodes: {
                    portugal: 'Canzoni portoghesi',
                    spain: 'Canzoni spagnole',
                    italy: 'Canzoni italiane',
                    all: 'Festa'
                },
                waiting: 'WAITING',
                error: 'ERRORE',
                home: 'Menù',
                closed: 'Chiudere',
                back_to_edit: 'Atrás',
                edit_again: 'Outra vez',
                save_game: 'Guardar',
                restart: 'Ricomincia',
                filter_options: {
                    all: 'Senza Filtro',
                    genre: 'Genere Musicale',
                    rhythmic_level: 'Difficoltà Ritmica',
                    meter_level: 'Dificultad Métrica',
                    melodic_level: 'Difficoltà Melodica'
                },
                filter_description: {
                    genre: { 
                        Lullaby: 'Ninna Nanna',
                        ChildrenSong: 'Filastrocca',
                        DanceSong: 'Danza'
                    },
                    rhythmic_level: {
                        '1': 'Facile',
                        '2': 'Medio',
                        '3': 'Difficile'
                    },
                    meter_level: {
                        '1': 'Binario',
                        '2': 'Ternario',
                        '3': 'Libero/Polirítmico'
                    },
                    melodic_level: {
                        '1': 'Facile',
                        '2': 'Medio',
                        '3': 'Difficile'
                    },
                }
            },
        }
    },
}
export default messages;